import SectionHeader from "@/components/SectionHeader";
import { Reveal } from "@/components/Reveal";
import { getIcon } from "@/components/iconMap";

export const Services = ({ services = [] }) => {
  return (
    <section data-testid="services-section" className="py-24 lg:py-32 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeader
          index="03"
          eyebrow="What I offer"
          title="Services"
          description="From the first interview to the final pixel — here's how I help teams ship products people actually understand."
        />

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {services.map((s, i) => {
            const Icon = getIcon(s.icon);
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.08}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full rounded-2xl border border-white/10 bg-surface p-7 lg:p-8 hover:border-white/25 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="flex items-start justify-between mb-8">
                    <Icon size={26} className="text-cream" strokeWidth={1.4} />
                    <span className="font-heading text-sm text-ash tabular-nums">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg lg:text-xl tracking-tight text-cream mb-3">{s.title}</h3>
                  <p className="text-ash text-sm leading-relaxed">{s.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
